import React, {useEffect, useState} from 'react';
import {Flex, Box, FormLabel, Text, RadioGroup, Radio} from '@chakra-ui/react';
import {CustomInput, CustomSelect, CustomCheckbox} from '../../General/FormInputs';
import {useForm} from 'react-hook-form';

import {get} from '../../../service/ApiService';
import {Department, OpportunityPlan} from '../../../service/Urls';
import Select, {components} from 'react-select';
import ErrorHelper from '../../../service/ErrorHelper';
import {useClientOpp} from '../../../views/Maintenance/OppPlanMaintenance';
import BoxCard from '../../General/BoxCard';
import ServiceTypes from '../../../constants/ServiceTypes';
import Questions from './BonusEntry/Questions';
import {isAdmin} from '../../../helpers/localStorage';
import EmployeeSelect from '../../Employee/EmployeeSelect';

const OppBonusEntry = props => {
  const {client} = useClientOpp();
  const [employees, setEmployees] = useState([]);
  const [employee, setEmployee] = useState({});
  const [questions, setQuestions] = useState([]);
  const [question, setQuestion] = useState(null);
  const [serviceType, setServiceType] = useState(ServiceTypes.FUNERAL);
  const [_, setElements] = useState({});
  const [department, setDepartment] = useState('');
  const [regions] = useState([]);
  const [region, setRegion] = useState(null);
  const [options, setOptions] = useState([]);
  const [toast, setToast] = useState('');
  const {
    register,
    handleSubmit,
    reset,
    control,
    getValues,
    setValue,
    formState: {errors},
  } = useForm({defaultValues: {...client, ...employee, ...question}});
  useEffect(async () => {
    setElements({
      departments: (
        <CustomSelect placeholder="Select a client region" name="Client Region" id="loRegion" register={register} errors={errors}></CustomSelect>
      ),
    });
  }, []);

  useEffect(async () => {
    if (client?.opp) {
      const response = await get(OpportunityPlan.RECORD + '/' + client.opp.id + '/employees');
      response.data.sort((a, b) => a.emName.localeCompare(b.emName));
      setEmployees(response.data);
      const opts = employees.map(em => {
        return (
          <option key={em.id} value={em.emCode}>
            {em.emCode + ' | ' + em.emName + ' | ' + em.emDept}
          </option>
        );
      });
      setOptions(opts);
      setFormValues();
      // setSel(0);
    }
  }, [client]);

  useEffect(() => {
    if (employees?.length) {
      setEmployee(employees[0]);
    }
  }, [employees]);

  // When either the employee or client changes, we'll combine them into a single object and set it in the context.
  const setFormValues = () => {
    const data = {...client.client, ...employee, ...question};
    // console.log('data:', JSON.stringify(data));
    reset(data);
  };

  useEffect(() => {
    if (question !== null) {
      setFormValues();
    }
  }, [question]);

  useEffect(async () => {
    if (employee?.id) {
      if (employee?.loSince) {
        employee.loSince = employee.loSince.replaceAll('/', '-');
        employee.loSince = employee.loSince.substring(0, employee.loSince.indexOf('T') > 0 ? employee.loSince.indexOf('T') : employee.loSince.length);
      }
      setRegion(employee.regionId);
      if (employee !== null) {
        const department = await get(`${Department.LIST}?DpCode=${employee.emDept}`);
        if (department.data[0]) setDepartment(department.data[0].dpDesc);
        const response = await get(OpportunityPlan.BONUSES + '/' + employee.id);
        setQuestions(response.data);
        setFormValues();
      }
    }
    // console.log(JSON.stringify(employee));
  }, [employee]);

  const changeEmployee = val => {
    const selectedEmployee = employees.find(empl => empl.id == val);
    setEmployee(selectedEmployee);
    // setSel(employees.findIndex(loc => loc.emCode == val.target.value));
  };

  // parts of the custom search box. mainly for styling and limiting to 5 options at a time.
  const MenuList = ({children, ...props}) => {
    return (
      <components.MenuList {...props}>
        {Array.isArray(children) ? children.slice(0, props.selectProps?.maxOptions) /* Options */ : children /* NoOptionsLabel */}
      </components.MenuList>
    );
  };

  const customStyles = {
    container: provided => ({
      ...provided,
      width: '100%',
      'margin-bottom': 3,
    }),
  };

  const SearchSelect = props => {
    return (
      <Box>
        <FormLabel mb="-0.5" ml="1" fontSize="sm">
          {props.name}
        </FormLabel>
        <Select
          options={props.options ?? []}
          components={{MenuList}}
          styles={customStyles}
          defaultValue={options[regions.findIndex(re => re.id == region)]}
          maxOptions={5}
          menuPortalTarget={document.body}
          menuPosition={'fixed'}
          {...props}
        />
      </Box>
    );
  };

  useEffect(() => {
    setElements({
      locations: (
        <SearchSelect
          placeholder="Select a Employee"
          name="Employee"
          id="loRegion"
          register={register}
          errors={errors}
          options={employee?.id ? options : []}
        />
      ),
    });
  }, [options]);

  return (
    <Box mr="2">
      <Box mb={4}>
        <EmployeeSelect oppId={client?.opp?.id} setEmployeeId={changeEmployee} />
      </Box>

      <form>
        <Flex>
          <BoxCard mr="2" w="85%">
            <Flex>
              <Box w="75%">
                <Flex>
                  <CustomInput register={register} id="emCode" name="Employee Code" errors={errors} isReadOnly={true} w="20%" />
                  <CustomInput register={register} id="emName" name="Employee Name" isReadOnly={true} errors={errors} w="60%" />
                  <CustomCheckbox
                    control={control}
                    isChecked={question?.m2Active}
                    initial={question?.m2Active ? 1 : 0}
                    id="m2Active"
                    name="Inactive"
                    mt="6"
                    isReadOnly={true}
                    w="10%"
                  />
                </Flex>
                <Flex>
                  <CustomInput register={register} id="emDept" name="Department Code" errors={errors} isReadOnly={true} w="20%" />
                  <CustomInput
                    register={register}
                    id="emDeptDesc"
                    name="Department Name"
                    defaultValue={department}
                    isReadOnly={true}
                    errors={errors}
                    w="60%"
                  />
                </Flex>
                <CustomInput register={register} id="emTitle" name="Title" errors={errors} isReadOnly={true} />
                <CustomInput register={register} id="clRep" name="Acct. Rep" errors={errors} isReadOnly={true} />
              </Box>
            </Flex>
            <Questions
              register={register}
              control={control}
              errors={errors}
              serviceType={serviceType}
              questions={questions}
              client={client}
              employee={employee}
              setToast={setToast}
              setQuestion={setQuestion}
              question={question}
              setQuestions={setQuestions}
              getValues={getValues}
              setValue={setValue}
              handleSubmit={handleSubmit}
            />
          </BoxCard>
        </Flex>
      </form>
      <ErrorHelper toastResponse={toast} />
    </Box>
  );
};

export default OppBonusEntry;
